'use strict';

import React from 'react';
import PropTypes from 'prop-types';

/**
 * ProgressBar - Reusable progress bar component for usage visualization
 */
const ProgressBar = ({
    percentage,
    segments = null,
    showLabel = false,
    showValue = false,
    label = '',
    className = ''
}) => {
    // Single progress bar
    if (!segments) {
        const getUsageClass = (percent) => {
            if (percent >= 80) return 'usage-high';
            if (percent >= 50) return 'usage-medium';
            return 'usage-low';
        };

        return (
            <div className={`el-progress-bar ${className}`}>
                <div 
                    className={`progress-fill ${getUsageClass(percentage)}`}
                    style={{ width: `${Math.min(100, Math.max(0, percentage))}%` }}
                />
            </div>
        );
    }

    // Multi-segment progress bar
    const totalWeight = segments.reduce((sum, segment) => sum + segment.value, 0);
    
    return (
        <div className={`el-progress-bar multi-segment ${className}`}>
            {segments.map((segment, index) => {
                const width = totalWeight > 0 ? (segment.value / totalWeight) * 100 : 0;
                return (
                    <div
                        key={index}
                        className="segment"
                        style={{ 
                            width: `${width}%`,
                            backgroundColor: segment.color || '#007aff'
                        }}
                        title={segment.label}
                    />
                );
            })}
        </div>
    );
};

ProgressBar.propTypes = {
    percentage: PropTypes.number,
    segments: PropTypes.arrayOf(PropTypes.shape({
        value: PropTypes.number.isRequired,
        color: PropTypes.string,
        label: PropTypes.string
    })),
    showLabel: PropTypes.bool,
    showValue: PropTypes.bool,
    label: PropTypes.string,
    className: PropTypes.string
};

export default ProgressBar;